<template lang="pug">
div.reportDashboard
    Row(style="margin-top: 8px")
        Col(span="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'reqsumnum'"
                :chartTitle="$t('dashboard.totalRequestCount')"
                :numeralFormat="'0.00a'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
                :apiEndpoint="apiEndpoint"
            )
        Col(span="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'servedsumnum'"
                :chartTitle="$t('dashboard.dataServedUsage')"
                :numeralFormat="'0.00ib'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
                :calculateFormula="$store.getters.chartData_servedsumnum"
                :apiEndpoint="apiEndpoint"
            )
    Row
        Col(:lg="12" :md="24")
            Card.dashBoardCard.chartWithButtonFooter
                BarChartWrapper.stableChartWrapper(
                    :chartType="'domainbarchart'"
                    :chartDataSetLabel="['dashboard.domainNameText']"
                    :titleDisplay="false"
                    :topNSize="5"
                    :withCard="false"
                    :direction="direction"
                    :barBorderColors="[colorScheme.blue.border]"
                    :barBackgroundColors="[colorScheme.blue.fill]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :apiEndpoint="apiEndpoint"
                )
        Col(:lg="12" :md="24")
            Card.dashBoardCard.chartWithButtonFooter
                BarChartWrapper.stableChartWrapper(
                    :chartType="'domainBarChartByDataUsage'"
                    :numeralFormat="'0.00ib'"
                    :chartDataSetLabel="['dashboard.dataServedUsage']"
                    :titleDisplay="false"
                    :topNSize="5"
                    :withCard="false"
                    :direction="direction"
                    :barBorderColors="[colorScheme.blue.border]"
                    :barBackgroundColors="[colorScheme.blue.fill]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :apiEndpoint="apiEndpoint"
                )
    Row
        Col(span="24")
            Card.dashBoardCard
                LineChartWrapper.stableChartWrapper(
                    :chartType="'reqlinechart'"
                    :chartDataSetLabel="['dashboard.totalRequestCount']"
                    :titleDisplay="false"
                    :withCard="false"
                    :linePointRadius="[4]"
                    :linePointHoverRadius="[8]"
                    :linePointBackgroundColor="['white']"
                    :linePointBorderWidth="[3]"
                    :lineBorderColors="[colorScheme.blue.border]"
                    :linePointHoverBorderWidth="[5]"
                    :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                    :linePointHoverBackgroundColor="['white']"
                    :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :apiEndpoint="apiEndpoint"
                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'reqsumnum'"
                    :chartTitle="$t('dashboard.totalRequestCount')"
                    :numeralFormat="'0.00a'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                    :apiEndpoint="apiEndpoint"
                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'reqRateNum'"
                    :chartTitle="$t('dashboard.avgRequestSpeedRate')"
                    :numStringSuffix="' / s'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                    :apiEndpoint="apiEndpoint"
                )
    Row
        Col(span="24")
            Card.dashBoardCard
                LineChartWrapper.stableChartWrapper(
                    :chartType="'cacheStatusLineChart'"
                    :chartDataSetLabel="['dashboard.dataServedUsage']"
                    :titleDisplay="false"
                    :numeralFormat="'0.00ib'"
                    :withCard="false"
                    :linePointRadius="[4]"
                    :linePointHoverRadius="[8]"
                    :linePointBackgroundColor="['white', 'white']"
                    :linePointBorderWidth="[3, 3]"
                    :lineBorderColors="[colorScheme.blue.border]"
                    :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
                    :linePointHoverBorderWidth="[5]"
                    :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                    :linePointHoverBackgroundColor="['white']"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :apiEndpoint="apiEndpoint"
                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'servedsumnum'"
                    :chartTitle="$t('dashboard.dataServedUsage')"
                    :numeralFormat="'0.00ib'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                    :apiEndpoint="apiEndpoint"
                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'servedByteRateNum'"
                    :chartTitle="$t('dashboard.avgServedSpeedRate')"
                    :numeralFormat="'0.00b'"
                    :numStringSuffix="' / s'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                    :apiEndpoint="apiEndpoint"
                )
</template>
<script>
import bus from "@/libs/bus.js";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";

import colorScheme from "@/data/colorScheme";
export default {
    name: "Report",
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 340,
            direction: "horizontal",
            apiEndpoint: "/monitor/edgechartdata-report",
        };
    },
    methods: {},
    mounted() {},
    computed: {
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/view/dashboard/Report.vue